import React, { useEffect } from "react";
import { AuthenticatedTemplate, useAccount, useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { AccountInfo } from "@azure/msal-browser";
import { Role } from "../shared/enums/Role";

const HomeContent = () => {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {}) as AccountInfo;

  useEffect(() => {
    const role = account != undefined && account?.idTokenClaims != undefined && account?.idTokenClaims["extension_Roles"];

    switch (role) {
      case Role.assessor:
      case Role.manager:
      case Role.root: {
        navigate("/applications");
        break;
      }
      case Role.provider: {
        navigate("/provider/applications");
        break;
      }
      case Role.kindergarten: {
        navigate("/kindergarten/pendingApplications");
        break;
      }
    }
  }, []);

  return <></>;
};

export const Home = () => {
  return (
    <AuthenticatedTemplate>
      <HomeContent />
    </AuthenticatedTemplate>
  );
};
